import React from 'react';
import '../template-file-css/document-file-template.css';


export const GFIT_InitialNursingAssessment = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GFIT_InitialNursingAssessment' className='file-pdf-document'>
            <div className='file-template'>

                <h3>
                    Nursing Assessment
                </h3>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Client Name:</span></td>
                        <td className='w-250'><span className='eleHeader'>Client DOB:</span></td>
                        <td className='w-250'><span className='eleHeader'>Parent/Guardian Name:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtClientName1" name="txtClientName1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtClientDob1" name="txtClientDob1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtParentGuardian1" name="txtParentGuardian1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Insurance #: </span></td>
                        <td className='w-250'><span className='eleHeader'>Nurse Name and Credentials:</span></td>
                        <td className='w-250'><span className='eleHeader'>Service Code:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtInsurance1" name="txtInsurance1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtNurseName1" name="txtNurseName1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtServiceCode1" name="txtServiceCode1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Date of Service: </span></td>
                        <td className='w-250'><span className='eleHeader'>Location: </span></td>
                        <td className='w-250'><span className='eleHeader'>Start Time:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="date" id="txtDateService1" name="txtDateService1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtLocation1" name="txtLocation1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="time" id="txtStartTime1" name="txtStartTime1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>End Time: </span></td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="time" id="txtEndTime1" name="txtEndTime1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <h4>
                    Relevant Medical Conditions
                </h4>
                <p className='w-750'>
                    <span className='eleHeader'>Prenatal History:</span>
                    <input type='checkbox' id='cbPrenatalHistory' name='cbPrenatalHistory' className='add-only' value='PrenatalHistory' />WNL
                    <textarea id='txtPrenatalHistory' name='txtPrenatalHistory' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Health at Birth:</span>
                    <input type='checkbox' id='cbHealth' name='cbHealth' className='add-only' value='Health' />WNL
                    <textarea id='txtHealth' name='txtHealth' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Current Health Issues: </span>
                    <input type='checkbox' id='cbCurrentHealth' name='cbCurrentHealth' className='add-only' value='CurrentHealth' />Denied
                    <textarea id='txtCurrentHealth' name='txtCurrentHealth' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Significant Injuries past or present:</span>
                    <input type='checkbox' id='cbSignificant' name='cbSignificant' className='add-only' value='Significant' />Denied
                    <textarea id='txtSignificant' name='txtSignificant' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Past Illnesses:</span>
                    <input type='checkbox' id='cbPastIllnesses' name='cbPastIllnesses' className='add-only' value='PastIllnesses' />Denied
                    <textarea id='txtPastIllnesses' name='txtPastIllnesses' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Allergies:</span>
                    <input type='checkbox' id='cbAllergies' name='cbAllergies' className='add-only' value='Allergies' />Denied
                    <textarea id='txtAllergies' name='txtAllergies' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Type of Allergy</span></td>
                        <td className='w-250'><span className='eleHeader'>List of Allergens</span></td>
                        <td className='w-250'><span className='eleHeader'>Reaction</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAllergy_1' name='cbAllergy_1' className='add-only' value='Allergy_1' />&nbsp;Food:&nbsp;
                            <input type="text" id="txtAllergy_1" name="txtAllergy_1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtListAllergens_1" name="txtListAllergens_1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtReaction_11" name="txtReaction_11" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAllergy_2' name='cbAllergy_2' className='add-only' value='Allergy_2' />&nbsp;Contact:&nbsp;
                            <input type="text" id="txtAllergy_2" name="txtAllergy_2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtListAllergens_2" name="txtListAllergens_2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtReaction_21" name="txtReaction_21" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAllergy_3' name='cbAllergy_3' className='add-only' value='Allergy_3' />&nbsp;Environmental:&nbsp;
                            <input type="text" id="txtAllergy_3" name="txtAllergy_3" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtListAllergens_3" name="txtListAllergens_3" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtReaction_31" name="txtReaction_31" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAllergy_4' name='cbAllergy_4' className='add-only' value='Allergy_4' />&nbsp;Drug:&nbsp;
                            <input type="text" id="txtAllergy_4" name="txtAllergy_4" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtListAllergens_4" name="txtListAllergens_4" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtReaction_41" name="txtReaction_41" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Alcohol/Substance/Tobacco Use:</span>
                    <input type='checkbox' id='cbSubstance' name='cbSubstance' className='add-only' value='Substance' />Denied
                    <textarea id='txtSubstance' name='txtSubstance' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Type</span></td>
                        <td className='w-250'><span className='eleHeader'>Frequency </span></td>
                        <td className='w-250'><span className='eleHeader'>Date of Last Use</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            Alcohol
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtFrequency_11" name="txtFrequency_11" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtDateLastUse_1" name="txtDateLastUse_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            Drug/Substance:&nbsp;
                            <input type="text" id="txtDrugSubstance_2" name="txtDrugSubstance_2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtFrequency_23" name="txtFrequency_23" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtDateLastUse_2" name="txtDateLastUse_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            Tobacco: &nbsp;
                            <input type="text" id="txtDrugSubstance_3" name="txtDrugSubstance_3" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtFrequency_31" name="txtFrequency_31" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtDateLastUse_3" name="txtDateLastUse_3" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h4>
                    Current Medications
                </h4>
                <table>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMedications_1' name='cbMedications_1' className='add-only' value='Medications_1' />Denied
                        </td>
                        <td className='w-300'>
                            <input type='checkbox' id='cbMedications_2' name='cbMedications_2' className='add-only' value='Medications_2' />Compliant with medications
                        </td>
                        <td className='w-300'>
                            <input type='checkbox' id='cbMedications_3' name='cbMedications_3' className='add-only' value='Medications_3' />Non-compliant with medications
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-130'><span className='eleHeader'>Medication Name</span></td>
                        <td className='w-120'><span className='eleHeader'>Dose/Frequency </span></td>
                        <td className='w-100'><span className='eleHeader'>Prescribed by?</span></td>
                        <td className='w-150'><span className='eleHeader'>When? </span></td>
                        <td className='w-150'><span className='eleHeader'>Next refill?  </span></td>
                        <td className='w-100'><span className='eleHeader'>Side Effects</span></td>
                    </tr>
                    <tr>
                        <td className='w-130'>
                            <input type="text" id="txtMedicationName_1" name="txtMedicationName_1" className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type="text" id="txtDoseFrequency_1" name="txtDoseFrequency_1" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtPrescribedBy_1" name="txtPrescribedBy_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtWhen_1" name="txtWhen_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtNextRefill_1" name="txtNextRefill_1" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtSideEffects_1" name="txtSideEffects_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-130'>
                            <input type="text" id="txtMedicationName_2" name="txtMedicationName_2" className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type="text" id="txtDoseFrequency_2" name="txtDoseFrequency_2" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtPrescribedBy_2" name="txtPrescribedBy_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtWhen_2" name="txtWhen_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtNextRefill_2" name="txtNextRefill_2" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtSideEffects_2" name="txtSideEffects_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-130'>
                            <input type="text" id="txtMedicationName_3" name="txtMedicationName_3" className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type="text" id="txtDoseFrequency_3" name="txtDoseFrequency_3" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtPrescribedBy_3" name="txtPrescribedBy_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtWhen_3" name="txtWhen_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtNextRefill_3" name="txtNextRefill_3" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtSideEffects_3" name="txtSideEffects_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-130'>
                            <input type="text" id="txtMedicationName_4" name="txtMedicationName_4" className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type="text" id="txtDoseFrequency_4" name="txtDoseFrequency_4" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtPrescribedBy_4" name="txtPrescribedBy_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtWhen_4" name="txtWhen_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtNextRefill_4" name="txtNextRefill_4" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtSideEffects_4" name="txtSideEffects_4" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h4>
                    Family Health History
                </h4>
                <p className='w-750'>
                    <span className='eleHeader'>Medical Problems  </span><span className='small'>(Heart disease, lung disease, cancer, strokes, diabetes, asthma, dementia, etc.) </span>
                    <textarea id='txtMedicalProblems' name='txtMedicalProblems' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Substance Abuse </span><span className='small'>(Alcohol, cannabis, stimulants, hallucinogens, sedatives, designer drugs, etc.)  </span>
                    <textarea id='txtSubstanceAbuse' name='txtSubstanceAbuse' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Mental Health/Behavioral Problems </span><span className='small'>(Depression, anxiety, bipolar, ADHD, schizophrenia, learning disorders, incarcerations, school behavioral problems, etc.) </span>
                    <textarea id='txtMentalHealthBehavioral' name='txtMentalHealthBehavioral' className='add-only'></textarea>
                </p>
                <h4>
                    Dental Screening
                </h4>
                <p className='w-750'>
                    <span className='eleHeader'>Date of Last Dental Visit:</span>
                    <input type='checkbox' id='cbDateLastDental' name='cbDateLastDental' className='add-only' value='DateLastDental' /> Unable to recall
                    <textarea id='txtDateLastDental' name='txtDateLastDental' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Rate Oral Hygiene:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRateOral_1' name='cbRateOral_1' className='add-only' value='RateOral_1' />Good
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRateOral_2' name='cbRateOral_2' className='add-only' value='RateOral_2' />Fair
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRateOral_3' name='cbRateOral_3' className='add-only' value='RateOral_3' />Poor
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRateOral_4' name='cbRateOral_4' className='add-only' value='RateOral_4' /> Other:
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtRateOralOther" name="txtRateOralOther" className='add-only' />
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>How many times a day does the individual brush their teeth?</span></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='radio' id='rbIndividual_Yes' name='rbIndividual' className='add-only' value='1' /> &nbsp; 0
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbIndividual_Ys' name='rbIndividual' className='add-only' value='2' /> &nbsp;  1
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbIndividual_No' name='rbIndividual' className='add-only' value='3' /> &nbsp;   2
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbIndividual_Ye' name='rbIndividual' className='add-only' value='4' /> &nbsp;   3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='radio' id='rbIndividual_Noi' name='rbIndividual' className='add-only' value='5' /> &nbsp; Other:
                        </td>
                        <td className='w-200'>
                            &nbsp;
                        </td>
                        <td className='w-200'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type="text" id="txtIndividualOther" name="txtIndividualOther" className='add-only' />
                        </td>
                        <td className='w-200'>
                            &nbsp;
                        </td>
                        <td className='w-200'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Detail Complaints/Needs:</span>
                    <input type='checkbox' id='cbDetailComplaints' name='cbDetailComplaints' className='add-only' value='DetailComplaints' /> Denied
                    <textarea id='txtDetailComplaints' name='txtDetailComplaints' className='add-only'></textarea>
                </p>
                <h4>
                    Vision Screening
                </h4>
                <p className='w-750'>
                    <span className='eleHeader'>Does the individual wear corrective lenses </span><span className='small'>(i.e., glasses, contacts)?</span>
                    <input type='radio' id='rbCorrective_Yes' name='rbCorrective' className='add-only' value='1' />&nbsp;  Denied      &nbsp;
                    <input type='radio' id='rbCorrective_No' name='rbCorrective' className='add-only' value='0' />&nbsp;  Yes
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the individual present with any undiagnosed vision impairments? </span>
                    <input type='radio' id='rbUndiagnosed_Yes' name='rbUndiagnosed' className='add-only' value='1' />&nbsp;  No  &nbsp;
                    <input type='radio' id='rbUndiagnosed_No' name='rbUndiagnosed' className='add-only' value='0' />&nbsp;  Yes
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Additional comments:</span>
                    <input type='checkbox' id='cbAdditionalComments' name='cbAdditionalComments' className='add-only' value='AdditionalComments' /> None
                    <textarea id='txtAdditionalComments' name='txtAdditionalComments' className='add-only'></textarea>
                </p>
                <h4>
                    Nutritional Status
                </h4>
                <p className='w-750'>
                    <span className='eleHeader'>Individual has history of binge eating/induced vomiting? </span>
                    <input type='radio' id='rbEating_Yes' name='rbEating' className='add-only' value='1' />&nbsp;  Denied   &nbsp;
                    <input type='radio' id='rbEating_No' name='rbEating' className='add-only' value='0' />&nbsp;  Yes (describe below):
                    <textarea id='txtEating' name='txtEating' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Number of Meals Per Day: </span></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='radio' id='rbMeals_Yes' name='rbMeals' className='add-only' value='1' /> &nbsp; 0
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbMeals_Ys' name='rbMeals' className='add-only' value='2' /> &nbsp;  1
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbMeals_No' name='rbMeals' className='add-only' value='3' /> &nbsp;   2
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbMeals_Ye' name='rbMeals' className='add-only' value='4' /> &nbsp;   3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='radio' id='rbMeals_Noi' name='rbMeals' className='add-only' value='5' /> &nbsp; Other:
                        </td>
                        <td className='w-200'>
                            &nbsp;
                        </td>
                        <td className='w-200'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type="text" id="txtMeals" name="txtMeals" className='add-only' />
                        </td>
                        <td className='w-200'>
                            &nbsp;
                        </td>
                        <td className='w-200'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Number of fast-food meals per week: </span></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='radio' id='rbMealsWeek_Yes' name='rbMealsWeek' className='add-only' value='1' /> &nbsp; 0
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbMealsWeek_Ys' name='rbMealsWeek' className='add-only' value='2' /> &nbsp;  1
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbMealsWeek_No' name='rbMealsWeek' className='add-only' value='3' /> &nbsp;   2
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbMealsWeek_Ye' name='rbMealsWeek' className='add-only' value='4' /> &nbsp;   3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='radio' id='rbMealsWeek_Noi' name='rbMealsWeek' className='add-only' value='5' /> &nbsp; Other:
                        </td>
                        <td className='w-200'>
                            &nbsp;
                        </td>
                        <td className='w-200'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type="text" id="txtMealsWeek" name="txtMealsWeek" className='add-only' />
                        </td>
                        <td className='w-200'>
                            &nbsp;
                        </td>
                        <td className='w-200'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>List appetite changes:  </span>
                    <input type='radio' id='rbAppetite_Yes' name='rbAppetite' className='add-only' value='1' />&nbsp;  Denied     &nbsp;
                    <input type='radio' id='rbAppetite_No' name='rbAppetite' className='add-only' value='0' />&nbsp;  Yes (describe below):
                    <textarea id='txtAppetite' name='txtAppetite' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>List significant weight loss/gain:  </span>
                    <input type='radio' id='rbWeight_Yes' name='rbWeight' className='add-only' value='1' />&nbsp;  Denied     &nbsp;
                    <input type='radio' id='rbWeight_No' name='rbWeight' className='add-only' value='0' />&nbsp;  Yes (describe below):
                    <textarea id='txtWeight' name='txtWeight' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the individual have an eating disorder?  </span>
                    <input type='radio' id='rbDisorder_Yes' name='rbDisorder' className='add-only' value='1' />&nbsp;  Denied   &nbsp;
                    <input type='radio' id='rbDisorder_No' name='rbDisorder' className='add-only' value='0' />&nbsp;  Yes (describe below):
                    <textarea id='txtDisorder' name='txtDisorder' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is the individual on a medically prescribed diet? </span>
                    <input type='radio' id='rbPrescribedDiet_Yes' name='rbPrescribedDiet' className='add-only' value='1' />&nbsp;  Denied  &nbsp;
                    <input type='radio' id='rbPrescribedDiet_No' name='rbPrescribedDiet' className='add-only' value='0' />&nbsp;  Yes (describe below):
                    <textarea id='txtPrescribedDiet' name='txtPrescribedDiet' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the individual desire to lose or gain weight? </span>
                    <input type='radio' id='rbLoseGain_Yes' name='rbLoseGain' className='add-only' value='1' />&nbsp;  Denied   &nbsp;
                    <input type='radio' id='rbLoseGain_No' name='rbLoseGain' className='add-only' value='0' />&nbsp;  Yes (describe below):
                    <textarea id='txtLoseGain' name='txtLoseGain' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is or has the individual been sexually active?  </span>
                    <input type='radio' id='rbSexually_Yes' name='rbSexually' className='add-only' value='1' />&nbsp;  Denied  &nbsp;
                    <input type='radio' id='rbSexually_No' name='rbSexually' className='add-only' value='0' />&nbsp;  Yes
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is the individual pregnant? </span>
                    <input type='radio' id='rbPregnant_Yes' name='rbPregnant' className='add-only' value='1' />&nbsp;  Male (N/A)  &nbsp;
                    <input type='radio' id='rbPregnant_No' name='rbPregnant' className='add-only' value='0' />&nbsp;  Denied  &nbsp;
                    <input type='radio' id='rbPregnant_Ni' name='rbPregnant' className='add-only' value='0' />&nbsp; Yes (details below):
                    <textarea id='txtPregnant' name='txtPregnant' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Date of last menstruation: </span>
                    <input type='radio' id='rbMenstruation_Yes' name='rbMenstruation' className='add-only' value='1' />&nbsp;  Male (N/A) &nbsp;
                    <input type='radio' id='rbMenstruation_No' name='rbMenstruation' className='add-only' value='0' />&nbsp;  Never menstruated
                    <textarea id='txtMenstruation' name='txtMenstruation' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Additional Comments: </span>
                    <textarea id='txtAdditionalComments_1' name='txtAdditionalComments_1' className='add-only'></textarea>
                </p>
                <h4>
                    Recent Mood Changes
                </h4>
                <p className='w-750'>
                    <span className='eleHeader'>Describe any recent mood changes: </span>
                    <textarea id='txtRecentMood' name='txtRecentMood' className='add-only'></textarea>
                </p>
                <h4>
                    Sleep Patterns
                </h4>
                <p className='w-750'>
                    <span className='eleHeader'>List any sleep problems the individual has been experiencing: </span>
                    <textarea id='txtSleepProblems' name='txtSleepProblems' className='add-only'></textarea>
                </p>
                <h4>
                    Functional Screening
                </h4>
                <p className='w-750'>
                    <span className='eleHeader'>Is the individual able to perform age-appropriate activities of daily living independently? </span>
                    <input type='radio' id='rbAppropriate_Yes' name='rbAppropriate' className='add-only' value='1' />&nbsp; Yes   &nbsp;
                    <input type='radio' id='rbAppropriate_No' name='rbAppropriate' className='add-only' value='0' />&nbsp;  No (describe below):
                    <textarea id='txtAppropriate' name='txtAppropriate' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the individual's physical health negatively impact other activities? </span>
                    <input type='radio' id='rbPhysicalHealth_Yes' name='rbPhysicalHealth' className='add-only' value='1' />&nbsp; Yes  &nbsp;
                    <input type='radio' id='rbPhysicalHealth_No' name='rbPhysicalHealth' className='add-only' value='0' />&nbsp;  No (describe below):
                    <textarea id='txtPhysicalHealth' name='txtPhysicalHealth' className='add-only'></textarea>
                </p>
                <h4>
                    Hygiene
                </h4>
                <p className='w-750'>
                    <span className='eleHeader'>Describe the individual's hygiene: </span>
                    <textarea id='txtPhysicalHygiene' name='txtPhysicalHygiene' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>The individual has problems with enuresis and/or encopresis? </span>
                    <input type='radio' id='rbEnuresis_Yes' name='rbEnuresis' className='add-only' value='1' />&nbsp; Denied   &nbsp;
                    <input type='radio' id='rbEnuresis_No' name='rbEnuresis' className='add-only' value='0' />&nbsp;  No (describe below):
                    <textarea id='txtEnuresis' name='txtEnuresis' className='add-only'></textarea>
                </p>
                <h4>
                    Pain Screening
                </h4>
                <p className='w-750'>
                    <span className='eleHeader'>Is the individual currently complaining of pain?</span>
                    <input type='radio' id='rbComplaining_Yes' name='rbComplaining' className='add-only' value='1' />&nbsp; Denied  &nbsp;
                    <input type='radio' id='rbComplaining_No' name='rbComplaining' className='add-only' value='0' />&nbsp;  Yes (describe below):
                    <textarea id='txtComplaining' name='txtComplaining' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>If so, give pain rating: </span>
                    <textarea id='txtComplainingRating' name='txtComplainingRating' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>If the individual has pain that interferes with daily lifestyle, please explain below:</span>
                    <textarea id='txtInterferes' name='txtInterferes' className='add-only'></textarea>
                </p>
                <h4>
                    Vital Signs
                </h4>
                <p className='w-750'>
                    <span className='eleHeader'>Vital Signs:</span>
                    <input type='checkbox' id='cbVitalSigns' name='cbVitalSigns' className='add-only' value='VitalSigns' /> Not taken due to telehealth session
                </p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>BP:</span></td>
                        <td className='w-250'><span className='eleHeader'>Pulse:</span></td>
                        <td className='w-250'><span className='eleHeader'>Respiration:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtBp" name="txtBp" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtPulse" name="txtPulse" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtRespiration" name="txtRespiration" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Temp:</span></td>
                        <td className='w-250'><span className='eleHeader'>Height:</span></td>
                        <td className='w-250'><span className='eleHeader'>Weight:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtTemp" name="txtTemp" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtHeight" name="txtHeight" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtWeight1" name="txtWeight1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>BMI:</span></td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtBmi" name="txtBmi" className='add-only' />
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>


                <h3>
                    Abnormal Involuntary Movement Scale (AIMS)
                </h3>
                <h4>
                    (Required ONLYfor clients on anti-psychotic medications)
                </h4>
                <p className='w-750'>
                    <input type='checkbox' id='cbNotApplicable' name='cbNotApplicable' className='add-only' value='NotApplicable' />  Not applicable
                </p>
                <p className='w-750'>
                    <strong>Movement Ratings:</strong> Rate highest severity observed. Rate movements that occur upon activation one less than those observed spontaneously. Select movement as well as code number that applies.
                </p>
                <p className='w-750'>
                    Rater:<input type="text" id="txtRater" name="txtRater" className='add-only' />
                </p>
                <h4>
                    Facial and Oral Movements
                </h4>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>1. Muscles of Facial Expression </span><span className='small'>(i.e., movements of forehead, eyebrows, periorbital area, cheeks, including frowning, blinking, smiling, grimacing) </span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbMuscles_Yes' name='rbMuscles' className='add-only' value='1' /> &nbsp; 0
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbMuscles_Ys' name='rbMuscles' className='add-only' value='2' /> &nbsp;  1
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbMuscles_No' name='rbMuscles' className='add-only' value='3' /> &nbsp;   2
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbMuscles_Ye' name='rbMuscles' className='add-only' value='4' /> &nbsp;   3
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbMuscles_Yi' name='rbMuscles' className='add-only' value='5' /> &nbsp;   4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>2. Lips and Perioral Area </span><span className='small'>(i.e., puckering, pouting, smacking)</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbLips_Yes' name='rbLips' className='add-only' value='1' /> &nbsp; 0
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbLips_Ys' name='rbLips' className='add-only' value='2' /> &nbsp;  1
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbLips_No' name='rbLips' className='add-only' value='3' /> &nbsp;   2
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbLips_Ye' name='rbLips' className='add-only' value='4' /> &nbsp;   3
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbLips_Yi' name='rbLips' className='add-only' value='5' /> &nbsp;   4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>3. Jaw</span><span className='small'> (i.e., biting, clenching, chewing, mouth opening, lateral movement)</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbJaw_Yes' name='rbJaw' className='add-only' value='1' /> &nbsp; 0
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbJaw_Ys' name='rbJaw' className='add-only' value='2' /> &nbsp;  1
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbJaw_No' name='rbJaw' className='add-only' value='3' /> &nbsp;   2
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbJaw_Ye' name='rbJaw' className='add-only' value='4' /> &nbsp;   3
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbJaw_Yi' name='rbJaw' className='add-only' value='5' /> &nbsp;   4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>4. Tongue </span><span className='small'> (i.e., Rate only increases in movement both in and out of mouth. NOT inability or sustain movement.)</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbTongue_Yes' name='rbTongue' className='add-only' value='1' /> &nbsp; 0
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbTongue_Ys' name='rbTongue' className='add-only' value='2' /> &nbsp;  1
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbTongue_No' name='rbTongue' className='add-only' value='3' /> &nbsp;   2
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbTongue_Ye' name='rbTongue' className='add-only' value='4' /> &nbsp;   3
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbTongue_Yi' name='rbTongue' className='add-only' value='5' /> &nbsp;   4
                        </td>
                    </tr>
                </table>
                <h4>
                    Extremity Movements
                </h4>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>5. Upper (arms, wrists, hands, fingers) Include chroreic movements (i.e., rapid, objectively purposeless, irregular, spontaneous) athetoid movements. DO NOT INCLUDE TREMOR.</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbUpper_Yes' name='rbUpper' className='add-only' value='1' /> &nbsp; 0
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbUpper_Ys' name='rbUpper' className='add-only' value='2' /> &nbsp;  1
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbUpper_No' name='rbUpper' className='add-only' value='3' /> &nbsp;   2
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbUpper_Ye' name='rbUpper' className='add-only' value='4' /> &nbsp;   3
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbUpper_Yi' name='rbUpper' className='add-only' value='5' /> &nbsp;   4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>6. Lower (legs, knees, ankles, toes) i.e., lateral knee movement, foot tapping, heel dropping, foot squirming, inversion and eversion of foot.</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbLower_Yes' name='rbLower' className='add-only' value='1' /> &nbsp; 0
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbLower_Ys' name='rbLower' className='add-only' value='2' /> &nbsp;  1
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbLower_No' name='rbLower' className='add-only' value='3' /> &nbsp;   2
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbLower_Ye' name='rbLower' className='add-only' value='4' /> &nbsp;   3
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbLower_Yi' name='rbLower' className='add-only' value='5' /> &nbsp;   4
                        </td>
                    </tr>
                </table>
                <h4>
                    Trunk Movements
                </h4>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>7. Neck, shoulders, hips </span><span className='small'>(i.e., rocking, twisting, squirming, pelvic gyrations)</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbNeck_Yes' name='rbNeck' className='add-only' value='1' /> &nbsp; 0
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbNeck_Ys' name='rbNeck' className='add-only' value='2' /> &nbsp;  1
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbNeck_No' name='rbNeck' className='add-only' value='3' /> &nbsp;   2
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbNeck_Ye' name='rbNeck' className='add-only' value='4' /> &nbsp;   3
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbNeck_Yi' name='rbNeck' className='add-only' value='5' /> &nbsp;   4
                        </td>
                    </tr>
                </table>
                <h4>
                    Global Judgments
                </h4>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>8. Severity of abnormal movements overall</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbSeverity_Yes' name='rbSeverity' className='add-only' value='1' /> &nbsp; 0
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbSeverity_Ys' name='rbSeverity' className='add-only' value='2' /> &nbsp;  1
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbSeverity_No' name='rbSeverity' className='add-only' value='3' /> &nbsp;   2
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbSeverity_Ye' name='rbSeverity' className='add-only' value='4' /> &nbsp;   3
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbSeverity_Yi' name='rbSeverity' className='add-only' value='5' /> &nbsp;   4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>9. Incapacitation due to abnormal movements</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbIncapacitation_Yes' name='rbIncapacitation' className='add-only' value='1' /> &nbsp; 0
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbIncapacitation_Ys' name='rbIncapacitation' className='add-only' value='2' /> &nbsp;  1
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbIncapacitation_No' name='rbIncapacitation' className='add-only' value='3' /> &nbsp;   2
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbIncapacitation_Ye' name='rbIncapacitation' className='add-only' value='4' /> &nbsp;   3
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbIncapacitation_Yi' name='rbIncapacitation' className='add-only' value='5' /> &nbsp;   4
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>10. Individual's awareness of abnormal movements. Rate only individual's report.
                            No awareness = 0 Aware, no distress = 1 Aware, mild distress = 2 Aware, moderate distress = 3 Aware, severe distress = 4 </span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbAwareness_Yes' name='rbAwareness' className='add-only' value='1' /> &nbsp; 0
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbAwareness_Ys' name='rbAwareness' className='add-only' value='2' /> &nbsp;  1
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbAwareness_No' name='rbAwareness' className='add-only' value='3' /> &nbsp;   2
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbAwareness_Ye' name='rbAwareness' className='add-only' value='4' /> &nbsp;   3
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbAwareness_Yi' name='rbAwareness' className='add-only' value='5' /> &nbsp;   4
                        </td>
                    </tr>
                </table>
                <h4>
                    Dental Status
                </h4>
                <p className='w-750'>
                    <span className='eleHeader'>11. Current problems with teeth and/or dentures</span>
                    <input type='radio' id='rbDentures_Yes' name='rbDentures' className='add-only' value='0' /> &nbsp; No &nbsp;
                    <input type='radio' id='rbDentures_No' name='rbDentures' className='add-only' value='1' /> &nbsp;  Yes
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>12. Are dentures usually worn?</span>
                    <input type='radio' id='rbWorn_Yes' name='rbWorn' className='add-only' value='0' /> &nbsp; No &nbsp;
                    <input type='radio' id='rbWorn_No' name='rbWorn' className='add-only' value='1' /> &nbsp;  Yes
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>13. Edentia?</span>
                    <input type='radio' id='rbEdentia_Yes' name='rbEdentia' className='add-only' value='0' /> &nbsp; No&nbsp;
                    <input type='radio' id='rbEdentia_No' name='rbEdentia' className='add-only' value='1' /> &nbsp;  Yes
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>14. Do movements disappear in sleep?</span>
                    <input type='radio' id='rbMovements_Yes' name='rbMovements' className='add-only' value='0' /> &nbsp; No&nbsp;
                    <input type='radio' id='rbMovements_No' name='rbMovements' className='add-only' value='1' /> &nbsp;  Yes
                </p>


                
                <h3>
                    Mental Status Exam
                </h3>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Appearance:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAppearance_1' name='cbAppearance_1' className='add-only' value='Appearance_1' />Well groomed
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAppearance_2' name='cbAppearance_2' className='add-only' value='Appearance_2' />Casual
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAppearance_3' name='cbAppearance_3' className='add-only' value='Appearance_3' />Disheveled
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAppearance_4' name='cbAppearance_4' className='add-only' value='Appearance_4' />Unkempt
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAppearance_5' name='cbAppearance_5' className='add-only' value='Appearance_5' />Bizarre
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAppearance_6' name='cbAppearance_6' className='add-only' value='Appearance_6' />Inappropriate
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAppearance_7' name='cbAppearance_7' className='add-only' value='Appearance_7' />Malodorous
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAppearance_8' name='cbAppearance_8' className='add-only' value='Appearance_8' />Physical Impairment
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Build:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBuild_1' name='cbBuild_1' className='add-only' value='Build_1' />Average Build
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBuild_2' name='cbBuild_2' className='add-only' value='Build_2' />Thin
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBuild_3' name='cbBuild_3' className='add-only' value='Build_3' />Overweight
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBuild_4' name='cbBuild_4' className='add-only' value='Build_4' />Obese
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBuild_5' name='cbBuild_5' className='add-only' value='Build_5' />Average height
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBuild_6' name='cbBuild_6' className='add-only' value='Build_6' />Tall
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBuild_7' name='cbBuild_7' className='add-only' value='Build_7' />Short
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Demeanor:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDemeanor_1' name='cbDemeanor_1' className='add-only' value='Demeanor_1' />Cooperative
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDemeanor_2' name='cbDemeanor_2' className='add-only' value='Demeanor_2' />Hostile
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDemeanor_3' name='cbDemeanor_3' className='add-only' value='Demeanor_3' />Guarded
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDemeanor_4' name='cbDemeanor_4' className='add-only' value='Demeanor_4' />Withdrawn
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDemeanor_5' name='cbDemeanor_5' className='add-only' value='Demeanor_5' />Preoccupied
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDemeanor_6' name='cbDemeanor_6' className='add-only' value='Demeanor_6' />Demanding
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDemeanor_7' name='cbDemeanor_7' className='add-only' value='Demeanor_7' />Seductive
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Affect:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAffect_1' name='cbAffect_1' className='add-only' value='Affect_1' />Normal
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAffect_2' name='cbAffect_2' className='add-only' value='Affect_2' />Labile
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAffect_3' name='cbAffect_3' className='add-only' value='Affect_3' />Flat
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAffect_4' name='cbAffect_4' className='add-only' value='Affect_4' />Worrisome
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAffect_5' name='cbAffect_5' className='add-only' value='Affect_5' />Sad
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAffect_6' name='cbAffect_6' className='add-only' value='Affect_6' />Apathetic
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Mood:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMood_1' name='cbMood_1' className='add-only' value='Mood_1' />Appropriate
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMood_2' name='cbMood_2' className='add-only' value='Mood_2' />Depressed
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMood_3' name='cbMood_3' className='add-only' value='Mood_3' />Anxious
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMood_4' name='cbMood_4' className='add-only' value='Mood_4' />Euphoric
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMood_5' name='cbMood_5' className='add-only' value='Mood_5' />Irritable
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMood_6' name='cbMood_6' className='add-only' value='Mood_6' />Dysphoric
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMood_7' name='cbMood_7' className='add-only' value='Mood_7' />Angry
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMood_8' name='cbMood_8' className='add-only' value='Mood_8' />Euthymic
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Behavior:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBehavior_1' name='cbBehavior_1' className='add-only' value='Behavior_1' />Appropriate
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBehavior_2' name='cbBehavior_2' className='add-only' value='Behavior_2' />Hyperactive
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBehavior_3' name='cbBehavior_3' className='add-only' value='Behavior_3' />Hypoactive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBehavior_4' name='cbBehavior_4' className='add-only' value='Behavior_4' />Restless
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBehavior_5' name='cbBehavior_5' className='add-only' value='Behavior_5' />Relaxed
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBehavior_7' name='cbBehavior_7' className='add-only' value='Behavior_7' />Other
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id="txtBehavior_7" name="txtBehavior_7" className='add-only' />
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Eye Contact:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEye_1' name='cbEye_1' className='add-only' value='Eye_1' />Average
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEye_2' name='cbEye_2' className='add-only' value='Eye_2' />Decreased
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEye_3' name='cbEye_3' className='add-only' value='Eye_3' />Increased
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Speech:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSpeech_1' name='cbSpeech_1' className='add-only' value='Speech_1' />Clear
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSpeech_2' name='cbSpeech_2' className='add-only' value='Speech_2' />Slurred
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSpeech_3' name='cbSpeech_3' className='add-only' value='Speech_3' />Rapid
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSpeech_4' name='cbSpeech_4' className='add-only' value='Speech_4' />Slow
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSpeech_5' name='cbSpeech_5' className='add-only' value='Speech_5' />Pressured
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSpeech_6' name='cbSpeech_6' className='add-only' value='Speech_6' />Soft
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSpeech_7' name='cbSpeech_7' className='add-only' value='Speech_7' />Loud
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSpeech_8' name='cbSpeech_8' className='add-only' value='Speech_8' />Monotone
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Thought Process:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThought_1' name='cbThought_1' className='add-only' value='Thought_1' />Logical
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThought_2' name='cbThought_2' className='add-only' value='Thought_2' />Coherent
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThought_3' name='cbThought_3' className='add-only' value='Thought_3' />Tight
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThought_4' name='cbThought_4' className='add-only' value='Thought_4' />Linear
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThought_5' name='cbThought_5' className='add-only' value='Thought_5' />Disorganized
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThought_6' name='cbThought_6' className='add-only' value='Thought_6' />Flight of Ideas
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThought_7' name='cbThought_7' className='add-only' value='Thought_7' />Loose Associations
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThought_8' name='cbThought_8' className='add-only' value='Thought_8' />Word Salad
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Thought Content:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbContent_1' name='cbContent_1' className='add-only' value='Content_1' />Within Normal Limits
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbContent_2' name='cbContent_2' className='add-only' value='Content_2' />Hallucinations
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbContent_3' name='cbContent_3' className='add-only' value='Content_3' />Delusions
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbContent_4' name='cbContent_4' className='add-only' value='Content_4' />Persecution Ideas
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbContent_5' name='cbContent_5' className='add-only' value='Content_5' />Suicidal Ideation
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbContent_6' name='cbContent_6' className='add-only' value='Content_6' />Homicidal Ideation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbContent_7' name='cbContent_7' className='add-only' value='Content_7' />Derealization
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbContent_8' name='cbContent_8' className='add-only' value='Content_8' />Depersonalization
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbContent_9' name='cbContent_9' className='add-only' value='Content_9' /> Ideas of Reference
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbContent_10' name='cbContent_10' className='add-only' value='Content_10' />Preoccupations
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbContent_11' name='cbContent_11' className='add-only' value='Content_11' />Strange Experiences
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbContent_12' name='cbContent_12' className='add-only' value='Content_12' /> Obsessions
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Insight:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbInsight_1' name='cbInsight_1' className='add-only' value='Insight_1' />Age Appropriate
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbInsight_2' name='cbInsight_2' className='add-only' value='Insight_2' />Limited
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbInsight_3' name='cbInsight_3' className='add-only' value='Insight_3' />Poor
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbInsight_4' name='cbInsight_4' className='add-only' value='Insight_4' />Unclear
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Judgment:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbJudgment_1' name='cbJudgment_1' className='add-only' value='Judgment_1' />Age Appropriate
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbJudgment_2' name='cbJudgment_2' className='add-only' value='Judgment_2' />Limited
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbJudgment_3' name='cbJudgment_3' className='add-only' value='Judgment_3' />Poor
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbJudgment_4' name='cbJudgment_4' className='add-only' value='Judgment_4' />Unclear
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Memory:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMemory_1' name='cbMemory_1' className='add-only' value='Memory_1' />Intact
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMemory_2' name='cbMemory_2' className='add-only' value='Memory_2' />Recent Intact
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMemory_3' name='cbMemory_3' className='add-only' value='Memory_3' />Remote intact
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Orientation:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_1' name='cbOrientation_1' className='add-only' value='Orientation_1' />Person
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_2' name='cbOrientation_2' className='add-only' value='Orientation_2' />Place
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_3' name='cbOrientation_3' className='add-only' value='Orientation_3' />Time
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_4' name='cbOrientation_4' className='add-only' value='Orientation_4' />Situation
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Motivation:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMotivation_1' name='cbMotivation_1' className='add-only' value='Motivation_1' />Good
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMotivation_2' name='cbMotivation_2' className='add-only' value='Motivation_2' />Fair
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMotivation_3' name='cbMotivation_3' className='add-only' value='Motivation_3' />Poor
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMotivation_4' name='cbMotivation_4' className='add-only' value='Motivation_4' />Unclear
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments regarding any items of concerns above outside of normal limits:</span>
                    <textarea id='txtNormalLimits' name='txtNormalLimits' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Summary</span>
                    <textarea id='txtSummary' name='txtSummary' className='add-only'></textarea>
                </p>
                <h4>
                    Recommendations/Plan
                </h4>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Service Recommendations::</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbServiceRecommendations_1' name='cbServiceRecommendations_1' className='add-only' value='ServiceRecommendations_1' />(C&A CORE) Individual/family therapy services 1-4 x monthly, CSI 2-8 x monthly, family skills training 1-4 x monthly.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbServiceRecommendations_2' name='cbServiceRecommendations_2' className='add-only' value='ServiceRecommendations_2' />(C&A IFI) IFI services 3-8 x weekly.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbServiceRecommendations_3' name='cbServiceRecommendations_3' className='add-only' value='ServiceRecommendations_3' />(Adult CORE) Individual/family therapy services 1-4 x monthly, PSR-I 2-8 x monthly, case management 2-8x monthly, family skills training 1-4 x monthly.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbServiceRecommendations_4' name='cbServiceRecommendations_4' className='add-only' value='ServiceRecommendations_4' />Other: <input type="text" id="txtServiceRecommendations" name="txtServiceRecommendations" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Labs Requested Today?:</span>
                    <input type='radio' id='rbLabs1_Yes' name='rbLabs1' className='add-only' value='0' /> &nbsp; No &nbsp;
                    <input type='radio' id='rbLabs1_No' name='rbLabs1' className='add-only' value='1' /> &nbsp;  Yes
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Medical Referrals Provided:</span>
                    <input type='radio' id='rbLabsMedical1_Yes' name='rbLabsMedical1' className='add-only' value='0' /> &nbsp; No &nbsp;
                    <input type='radio' id='rbLabsMedical1_No' name='rbLabsMedical1' className='add-only' value='1' /> &nbsp;  Yes, please list:
                    <textarea id='txtLabsMedical' name='txtLabsMedical' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Additional Recommendations::</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAdditionalRecommendations_1' name='cbAdditionalRecommendations_1' className='add-only' value='AdditionalRecommendations_1' />None
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAdditionalRecommendations_2' name='cbAdditionalRecommendations_2' className='add-only' value='AdditionalRecommendations_2' />Medical Follow up
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAdditionalRecommendations_3' name='cbAdditionalRecommendations_3' className='add-only' value='AdditionalRecommendations_3' />Referral to primary care physician
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAdditionalRecommendations_4' name='cbAdditionalRecommendations_4' className='add-only' value='AdditionalRecommendations_4' />Fitness and Nutrition Education
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAdditionalRecommendations_5' name='cbAdditionalRecommendations_5' className='add-only' value='AdditionalRecommendations_5' />Health Education
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAdditionalRecommendations_6' name='cbAdditionalRecommendations_6' className='add-only' value='AdditionalRecommendations_6' />Medication Education
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAdditionalRecommendations_7' name='cbAdditionalRecommendations_7' className='add-only' value='AdditionalRecommendations_7' />Chronic Disease Education/Training
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAdditionalRecommendations_8' name='cbAdditionalRecommendations_8' className='add-only' value='AdditionalRecommendations_8' />Substance Abuse/Relapse Prevention Training
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAdditionalRecommendations_9' name='cbAdditionalRecommendations_7' className='add-only' value='AdditionalRecommendations_9' />Smoking Cessation Training/Classes
                        </td>
                        <td className='w-375'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAdditionalRecommendations_10' name='cbAdditionalRecommendations_10' className='add-only' value='AdditionalRecommendations_10' />Other:
                        </td>
                        <td className='w-375'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id="txtAdditionalRecommendations_10" name="txtAdditionalRecommendations_10" className='add-only' />
                        </td>
                        <td className='w-375'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Follow up: </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbFollowMeals_Yes' name='rbFollowMeals' className='add-only' value='1' /> 4-8 weeks
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbFollowMeals_Ys' name='rbFollowMeals' className='add-only' value='2' /> 8-12 weeks
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbFollowMeals_No' name='rbFollowMeals' className='add-only' value='3' /> Annually/as needed
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbFollowMeals_Noi' name='rbFollowMeals' className='add-only' value='5' /> &nbsp; Other:
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtFollowMeals" name="txtFollowMeals" className='add-only' />
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-300'> Nurse Signature/Credentials: </td>
                        <td className='small w-300'> Nurse Name/Credentials (Print): </td>
                        <td className='small w-150'> Date: </td>
                    </tr>
                </table>




            </div>
        </form>

    )
}